module.exports = __webpack_public_path__ + "static/media/image17.95831424.png";